// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:19.369Z
// Property: Park Place at Foley (ID: 6737460151192641)
// Collections: 26 amenities, 9 floorplans (live), 17 photos, 40 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192641",
  "property_external_id": "4973405",
  "property_zillow_url": "https://www.zillow.com/apartments/foley-al/park-place/5XqWcK/",
  "property_apartments_url": "https://www.apartments.com/park-place-at-foley-foley-al/zbjy0cy",
  "property_google_business_url": "https://www.google.com/maps/place/Park+Place+at+Foley/data=!4m2!3m1!1s0x0:0x22f001f063388fae?sa=X&ved=2ahUKEwiNgIP8yrySAxVw6ckDHejkJ_8Q_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8442831891",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-place-at-foley",
  "property_name": "Park Place at Foley",
  "property_website_url": "https://www.parkplaceatfoley.com/",
  "property_domain": "https://www.parkplaceatfoley.com/",
  "property_address": "400 Park Ave",
  "property_full_address": "400 Park Ave, Foley, AL 36535",
  "property_address_1": "400 Park Ave",
  "property_address_2": null,
  "property_address_city": "Foley",
  "property_address_state": "AL",
  "property_address_zip_full": "36535-1106",
  "property_address_zip": "36535",
  "property_address_country": "US",
  "property_address_county": "Baldwin County",
  "property_neighborhood_address": "Baldwin County",
  "property_address_latitude": "30.37475239999999",
  "property_address_longitude": "-87.6904694",
  "property_email": "Foley@rreafresidential.com",
  "property_phone": "(251) 494-3562",
  "property_call_tracking_phone": "251-714-7121",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Park Place at Foley, your ideal living space awaits with versatile one, two, and three-bedroom floor plans. Indulge in top-notch amenities including a fitness center, spa, and tennis courts, all within a gated community. Experience maintenance-free living in Foley—your perfect home is just a click away!",
  "property_long_description": "Welcome to Park Place at Foley, your ideal living destination nestled in the heart of Foley, AL! Our beautifully designed apartment community offers a variety of spacious floor plans including one, two, and three-bedroom options to suit your lifestyle and needs. With an array of modern amenities, you’ll experience a perfect blend of comfort and convenience.\n\nStay active and healthy in our state-of-the-art fitness center, unwind at the clubhouse for social gatherings, or enjoy our tranquil courtyard and sundeck. Our controlled access ensures your safety, while amenities like on-site maintenance, a property manager available to assist you, and laundry facilities provide you with peace of mind.\n\nFor your convenience, we offer a package service, business center, and a unique breakfast/coffee concierge to kickstart your mornings. Our gated community includes a luxurious spa, tennis court, and even a car wash area for hassle-free living. Stay connected with high-speed Wi-Fi throughout the property and enjoy outdoor grilling options for weekend barbecues.\n\nAt Park Place at Foley, you’re not just finding an apartment; you’re discovering a lifestyle that prioritizes your comfort and convenience. Find your new home today—browse our availability or schedule a tour to visit our vibrant community! Whether you’re looking for a cozy one-bedroom or a spacious three-bedroom, Park Place at Foley has the perfect space waiting for you. Join us and elevate your living experience!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf1-8700-74c4-916c-cbc0955ed685.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and covered seating area.",
    "public_id": "01a08cf1-8700-74c4-916c-cbc0955ed685",
    "storage_key": "property/6737460151192641/01a08cf1-8700-74c4-916c-cbc0955ed685.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.83333333333334",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://dlpfoley.loftliving.com/login",
  "property_apply_now_url": "https://8873223.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-bc30-70f8-a64f-a28d7b3cb5be.webp",
  "property_primary_logo_media": {
    "alt_text": "Park Place at Foley logo",
    "public_id": "019e1ddd-bc30-70f8-a64f-a28d7b3cb5be",
    "storage_key": "property/6737460151192641/019e1ddd-bc30-70f8-a64f-a28d7b3cb5be.webp",
    "width": 1182,
    "height": 449
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-bc17-747f-8828-66fc2a8f83c7.webp",
  "property_secondary_logo_media": {
    "alt_text": "Park Place at Foley logo",
    "public_id": "019e1ddd-bc17-747f-8828-66fc2a8f83c7",
    "storage_key": "property/6737460151192641/019e1ddd-bc17-747f-8828-66fc2a8f83c7.webp",
    "width": 1174,
    "height": 441
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-bc17-747f-8828-66fc2a8f83c7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Park Place at Foley logo",
    "public_id": "019e1ddd-bc17-747f-8828-66fc2a8f83c7",
    "storage_key": "property/6737460151192641/019e1ddd-bc17-747f-8828-66fc2a8f83c7.webp",
    "width": 1174,
    "height": 441
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e8e86-e9c7-73f0-a8ed-4149cfd2e333.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-e9c7-73f0-a8ed-4149cfd2e333",
    "storage_key": "property/6737460151192641/019e8e86-e9c7-73f0-a8ed-4149cfd2e333.webp",
    "width": 1182,
    "height": 449
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#042062",
  "property_secondary_color": "#046976",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "742 - 1224",
  "property_sqft_min": "742",
  "property_sqft_max": "1224",
  "property_price_range": "1285 - 1705",
  "property_price_min": "1285",
  "property_price_max": "1705",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/people/Park-Place-at-Foley/61554358688248/",
  "property_instagram_url": "https://www.instagram.com/parkplaceatfoley",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSfDdsCkOmogRro84Y_AB8CI",
  "property_youtube_url": "https://www.youtube.com/watch?v=mchaHuVISsA",
  "property_yelp_url": "https://www.yelp.com/biz/dlp-foley-foley",
  "property_tiktok_url": "https://www.tiktok.com/@park.place.at.foley",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park Place at Foley",
  "property_home_romance_title": "Create Cherished Memories in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "<p>Near Park Ave and Pine Street lies the pleasant Park Place at Foley <a href=\"/floor-plans/\">apartment homes</a> in Foley, AL. Take a stroll to OWA Parks nearby or play golf at the Gulf Links Golf Center. The Snook Family YMCA, parks, and shopping outlets are right around the corner to help make every day and trip more like an adventure. Start your journey with us today at Park Place at Foley.</p>",
  "property_home_floorplans_blurb": "<p>Discover unparalleled living at <a href=\"/floor-plans/\">Park Place in Foley, Alabama</a>, where convenience meets adventure. Just an 8-minute drive from the renowned OWA Parks and Resort and 6-minute drive from Tanger Outlets Foley, our <a href=\"/floor-plans/\">apartments</a> offer the perfect blend of comfort and accessibility. Explore Downtown OWA, with its pedestrian-only streets brimming with diverse dining, shopping, and entertainment options. Experience the best of Foley living at Park Place, your gateway to adventure and convenience.</p>",
  "property_home_gallery_blurb": "At Park Place at Foley, your ideal home awaits. Choose from spacious one, two, or three-bedroom layouts designed for comfort and style. With amenities like a sparkling pool, sundeck, and modern kitchens featuring stainless steel appliances, every day feels like a getaway. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Park Place at Foley, where diverse floor plans, including one, two, and three-bedroom apartments, harmonize with the vibrant Foley community. Uncover local favorites and hidden gems just moments away, making your new home not just a place to live but a place to thrive. Embrace your neighborhood today!",
  "property_home_reviews_blurb": "Welcome to Park Place at Foley, where friendly management fosters a supportive community. Our residents appreciate that “management really listens to any problems you are having.” With pet-friendly amenities and a dedicated pet area, you and your furry friends can enjoy the outdoors. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Discover unparalleled living at <a href=\"/floor-plans/\">Park Place in Foley, Alabama</a>, where convenience meets adventure. Just an 8-minute drive from the renowned OWA Parks and Resort and 6-minute drive from Tanger Outlets Foley, our <a href=\"/floor-plans/\">apartments</a> offer the perfect blend of comfort and accessibility. Explore Downtown OWA, with its pedestrian-only streets brimming with diverse dining, shopping, and entertainment options. Experience the best of Foley living at Park Place, your gateway to adventure and convenience.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Park Place at Foley, you'll experience an easy lifestyle with our exceptional on-site amenities. Unwind with beautiful landscaping, a shimmering swimming pool with sundeck, and outdoor grilling station with pergola <a href=\"/neighborhood/\">right outside your door</a>. And the perks don't stop there - inside your very own apartment, you'll find a fireplace, balcony or patio, & plush carpet in bedrooms.</p>",
  "property_applynow_blurb": "At Park Place at Foley, your perfect home awaits in spacious one, two, or three-bedroom layouts. Enjoy premier amenities like a fitness center, cozy clubhouse, and serene sundeck. Experience effortless living with our on-site maintenance and convenient laundry services. Start your next chapter—lease online today!",
  "property_contactus_blurb": "At Park Place at Foley in beautiful Foley, AL, find the perfect fit with our thoughtfully designed one, two, and three-bedroom floor plans. Each home invites comfort and convenience, tailored for your lifestyle. Curious about availability or want to know more? Our leasing team is just a message away!",
  "property_faqs_blurb": "At Park Place at Foley, find the perfect home that fits your lifestyle with our diverse floor plans—whether you need a cozy one-bedroom or a spacious three-bedroom. Have questions? Our FAQs page is your go-to for everything you need to know about our vibrant community.",
  "property_floorplans_blurb": "<p>Three satisfying open floorplans of one, two, and three bedroom apartment homes for rent each include a balcony or patio to enhance <a href=\"/amenities/\">comfort and space</a>. Energy-efficient appliances and washer and dryer connections are also included. Select units have walk-in closets, luxury wood-designed floors, tile backsplash, and a fireplace. Some units have plush carpet in the bedroom, built-in wine racks, and designer cabinetry in the kitchen at Park Place at Foley.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Park Place at Foley, your ideal lifestyle awaits in one, two, or three-bedroom apartments. With amenities like a fitness center, serene sundeck, and tennis courts, every day feels like a retreat. Use our interactive community map to find your perfect home in Foley, AL today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Park Place at Foley, your ideal home awaits with stylish one, two, and three-bedroom floor plans designed for comfort and community. Enjoy vibrant living surrounded by great neighbors. Spread the love—refer a friend to experience the charm of Foley, AL, together!",
  "property_residentaccess_blurb": "At Park Place at Foley, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle needs. Experience seamless living with our dedicated resident portal, where you can effortlessly pay rent, schedule maintenance, and manage your community experience—all at your fingertips! Sign in today for a hassle-free living experience.",
  "property_reviews_blurb": "At Park Place at Foley, residents appreciate a welcoming atmosphere where \"management really listens\" to concerns. With a dedicated pet area for your furry friends and a refreshing pool to unwind by, our community offers a comfortable lifestyle for you and your pets. See what our residents have to say about living at our community!",
  "property_created_at": "1752257258279",
  "property_scheduletour_blurb": "At Park Place at Foley, find your perfect home in our thoughtfully designed one, two, or three-bedroom apartments. Experience comfort and community in a vibrant setting. Curious about life here? Schedule a tour today and hear firsthand from our residents about their exceptional experiences at our welcoming community in Foley, AL!",
  "property_thankyou_blurb": "Thank you for reaching out to Park Place at Foley! With our thoughtfully designed one, two, and three-bedroom floor plans, you're one step closer to finding your perfect home in sunny Foley, AL. A team member will connect with you soon—exciting living awaits!",
  "property_virtualtours_blurb": "<p>At Park Place at Foley, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Park Place at Foley",
  "property_seo_title_home": "Park Place at Foley | Apartments in Foley, AL",
  "property_seo_description_home": "\"Welcome to Park Place at Foley, where modern living meets comfort in the heart of Foley, AL. Choose from spacious one, two, and three-bedroom floor plans designed to suit your lifestyle. Enjoy a wealth of amenities including a state-of-the-art fitness center, serene spa, and inviting clubhouse. With controlled access, on-site maintenance, and a dedicated property manager, peace of mind is at your fingertips. Elevate your living experience with our tennis court, sundeck, and business center. Your dream home awaits—make it a reality today!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Foley, AL",
  "property_seo_description_floorplans": "Uncover your ideal living space at Park Place at Foley! Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Nestled in the heart of Foley, AL, each layout is crafted to complement your lifestyle. Browse our available apartment homes and envision the endless possibilities of your next chapter.",
  "property_seo_title_amenities": "Amenities | Foley, AL Apartments for Rent",
  "property_seo_description_amenities": "\"Step into the lifestyle you've always wanted at Park Place at Foley! Our thoughtfully designed one, two, and three-bedroom apartments come with a host of luxurious amenities, including a modern fitness center, relaxing spa, and vibrant clubhouse. Enjoy the outdoors on our sun-drenched sundeck or the tennis court, and benefit from convenient features like on-site maintenance, a business center, and package service. Located in charming Foley, AL, your new home awaits. Experience community living redefined—discover your ideal space today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Foley, AL",
  "property_seo_description_gallery": "Experience life at Park Place at Foley, where modern living meets vibrant community. With spacious one, two, and three-bedroom floor plans, you'll find the perfect home to fit your lifestyle. Enjoy top-notch amenities like a fitness center, clubhouse, and tennis court, along with conveniences such as controlled access, laundry service, and a business center. Picture yourself lounging on the sundeck or unwinding in the spa—this is more than just an apartment; it’s your sanctuary in Foley, AL. Come and see the lifestyle that awaits you!",
  "property_seo_title_virtualtours": "Virtual Tours | Park Place at Foley Apartments",
  "property_seo_description_virtualtours": "Experience modern living at Park Place at Foley, where comfort meets convenience in Foley, AL. From inviting one-bedroom layouts to spacious three-bedroom designs, our well-crafted floor plans cater to all lifestyles. Dive into our immersive virtual tour today and envision your perfect home among beautifully landscaped grounds and contemporary amenities. Your ideal apartment awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Park Place at Foley Apartments",
  "property_seo_description_interactivemap": "Unveil the charm of Park Place at Foley, where comfort meets convenience in the heart of Foley, AL. Choose from vibrant one, two, or three-bedroom apartments tailored to your lifestyle. Indulge in top-notch amenities including a fitness center, clubhouse, and even a tennis court. Navigate your future home effortlessly with our interactive community map—search for available apartments, compare pricing, and find a space that feels like yours. Join a community that prioritizes your every need while enjoying the serene courtyard and inviting sundeck. Your new adventure starts here!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Foley, AL",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle at Park Place at Foley, nestled in the heart of Foley, AL. From scenic parks to trendy dining spots, our community invites you to explore local favorites and points of interest just moments away. Learn about the neighborhood that makes coming home a true delight!",
  "property_seo_title_contact": "Contact Us | Park Place at Foley",
  "property_seo_description_contact": "Connect with us at Park Place at Foley, where spacious living meets Southern charm in beautiful Foley, AL. Whether you're searching for a cozy one-bedroom hideaway or a family-friendly three-bedroom retreat, our community has the perfect layout for you. Don't hesitate—your new home awaits! Have questions? Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Foley, AL",
  "property_seo_description_faqs": "Unlock the full potential of life at Park Place at Foley! Nestled in the heart of Foley, AL, our vibrant community offers diverse floor plans, including one, two, and three-bedroom apartments, paired with exceptional amenities. From a state-of-the-art fitness center and tranquil spa to a social clubhouse and tennis court, we cater to your lifestyle. Have questions? Our FAQs page is your go-to resource for insights into our gated community's facilities and services. Find your ideal home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Foley, AL",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Park Place at Foley, where comfort meets community in the heart of Foley, AL. With spacious one, two, and three-bedroom floor plans, our amenities cater to every need—enjoy a refreshing dip at the spa, invigorate your routine in our fitness center, or unwind at the sundeck. Gated access and on-site management ensure your peace of mind while our business center and coffee concierge elevate your daily life. Curious about your future home? See what our residents have to say about living at our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Foley, AL",
  "property_seo_description_applynow": "Elevate your lifestyle at Park Place at Foley, where modern comfort meets unmatched convenience in Foley, AL. Choose from spacious one, two, or three-bedroom floor plans tailored to your needs. Enjoy top-notch amenities like a fitness center, tennis court, and relaxing spa, plus perks like a breakfast concierge and convenient package service. Experience a vibrant community atmosphere complete with a clubhouse, sundeck, and manicured courtyard. Ready to claim your ideal living space? Embrace the exceptional—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Park Place at Foley",
  "property_seo_description_residentaccess": "\"Unlock the convenience of Park Place at Foley! Seamlessly manage your living experience with our resident portal—pay rent, request maintenance, and stay connected with your community, all in one place.\"",
  "property_seo_title_referafriend": "Refer A Friend | Park Place at Foley",
  "property_seo_description_referafriend": "\"At Park Place at Foley, great friends make great neighbors! Refer a friend today and unlock exclusive rewards in our vibrant community nestled in the heart of Foley, AL. Join us in creating unforgettable experiences together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Park Place at Foley",
  "property_seo_description_scheduletour": "Experience the charm of Park Place at Foley, where modern living meets Southern hospitality. Take a stroll through our vibrant community and envision your new home. Schedule a tour today and start your journey to comfortable living in beautiful Foley, AL!",
  "property_seo_title_privacy": "Privacy Policy | Park Place at Foley",
  "property_seo_description_privacy": "\"At Park Place at Foley, your peace of mind matters. Our privacy policy details how we protect your personal information while you enjoy all that our vibrant community in Foley, AL, has to offer. Curious about our commitment to your privacy? View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Park Place at Foley",
  "property_seo_description_accessibility": "\"At Park Place at Foley, we champion accessibility for all. Our commitment to digital inclusion ensures that everyone can navigate our community with ease. Join us in creating a welcoming environment where comfort meets convenience in Foley, AL.\"",
  "property_seo_title_sitemap": "Sitemap | Park Place at Foley",
  "property_seo_description_sitemap": "Uncover the hidden gems of Park Place at Foley, where comfort meets convenience in the heart of Foley, AL. Navigate our sitemap to unlock a world of community features, amenities, and floor plans designed just for you!",
  "property_seo_title_thankyou": "Thank You | Park Place at Foley",
  "property_seo_description_thankyou": "Thank you for reaching out to Park Place at Foley! We're excited to connect with you soon. Your journey to vibrant living in the heart of Foley, AL, is just beginning. Stay tuned for more details on making our community your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Foley, AL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660431",
  "amenities": [
    {
      "id": "ec_9aefc24fc2ecf5bc2abe0bf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e4595d16e677937f508fdff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8ee8bbec410687514aff6c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52ae5d3bd23d08d05f0457c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Payment Options",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db68e87447e442b2f534ed53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c719640d5a96148aedea631",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Management",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8b82cede989bf18fdee75d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Grilling Station With Pergola",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_252517a3fbf8828aec3358b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c25b8aeb73730f75015d4fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool With Sundeck",
      "amount": "false",
      "description": "Listed under COMMUNITY AMENITIES section.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d851ff3a3c24f1cbf49667da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5b01fdd22c5da24b6e4e02f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_387eb65a2ba5665199608c0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Cabinetry*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db944f163e0f5e0b83be103a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d110fb4bc653728d7dd70028",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Energy‑Efficient Stainless Steel Appliances",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb9c2d3840d92d0966db1934",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e3908ce87026d1aea4cf436",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Granite‑style Countertops*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0447c1860fccc5170359ec3f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Pantry With Built‑in Wine Racks*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a87f5fb182954a7e3b898b60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Luxury Wood‑designed Flooring*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d7e3ce9272b0d7ca189b376",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Master Bedroom With En‑suite*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1448d46e88641f801b7916e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e16be24892a2e96b1e3cd2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Open Concept Floor Plans",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_023e392e002788eedb85c29e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Plush Carpet in Bedrooms*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35515c99d3149ba7b2f7964e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Smart Outlets with USB Charging*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e28077bd8c43d776d1ad974",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaab7dbf347519e3242cedd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4fee99417275acd666f4b4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "Listed under APARTMENT FEATURES section.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_effde105-8b73-471d-99bf-80d597cd9ef0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-2ec9-77df-b6ca-8c6e34b23ff9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and covered seating area.",
        "public_id": "01a08cf2-2ec9-77df-b6ca-8c6e34b23ff9",
        "storage_key": "property/6737460151192641/01a08cf2-2ec9-77df-b6ca-8c6e34b23ff9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63eca384-c98e-4ecc-b03d-8132cefcdf12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-343b-77ff-9535-362e67f6e987.webp",
      "image_media": {
        "alt_text": "Living and dining room area with a couch, coffee table, and dining table with chairs.",
        "public_id": "01a08cf2-343b-77ff-9535-362e67f6e987",
        "storage_key": "property/6737460151192641/01a08cf2-343b-77ff-9535-362e67f6e987.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish living and dining room featuring a comfortable couch, coffee table, and elegant dining set, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living and dining room area with a couch, coffee table, and dining table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_093b63d5-a26a-4933-a8b6-00494e53febd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-36a5-717e-b64b-72de9e5fb57e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and a dining area.",
        "public_id": "01a08cf2-36a5-717e-b64b-72de9e5fb57e",
        "storage_key": "property/6737460151192641/01a08cf2-36a5-717e-b64b-72de9e5fb57e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring white cabinetry, sleek granite countertops, a double sink, and a adjacent dining area perfect for casual meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2188f6ac-defc-4a74-953a-1a6758b6394c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-3758-76ea-994e-af3ebd1ed8d2.webp",
      "image_media": {
        "alt_text": "Black stove and refrigerator in a kitchen with white cabinets and granite countertops.",
        "public_id": "01a08cf2-3758-76ea-994e-af3ebd1ed8d2",
        "storage_key": "property/6737460151192641/01a08cf2-3758-76ea-994e-af3ebd1ed8d2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring black appliances, white cabinetry, and granite countertops. A doorway reveals a washer and dryer.",
      "link": "",
      "alt_text": "Black stove and refrigerator in a kitchen with white cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20faf02a-5442-4281-8ba1-6e3ad8b0a8d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-2d9d-7115-abc0-f93a03acdaa2.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-size bed, white dresser, and coastal-themed decor.",
        "public_id": "01a08cf2-2d9d-7115-abc0-f93a03acdaa2",
        "storage_key": "property/6737460151192641/01a08cf2-2d9d-7115-abc0-f93a03acdaa2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a comfortable queen-size bed and ample storage in the dresser. The coastal-themed decor adds a serene touch.",
      "link": "",
      "alt_text": "Bright bedroom with a queen-size bed, white dresser, and coastal-themed decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8e76042-e2ed-4e8a-b63f-d0ee62ad4b75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-317c-747c-96c7-e425a6e8adba.webp",
      "image_media": {
        "alt_text": "Dining area with round table and four blue chairs, decorative mirror, and abstract art.",
        "public_id": "01a08cf2-317c-747c-96c7-e425a6e8adba",
        "storage_key": "property/6737460151192641/01a08cf2-317c-747c-96c7-e425a6e8adba.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy meals with family and friends in this charming dining area, featuring a stylish round table, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Dining area with round table and four blue chairs, decorative mirror, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b9fbe50-5329-4433-8732-10bae8cfa81a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-3630-7347-aa06-59893fd55efd.webp",
      "image_media": {
        "alt_text": "Park Place at Foley monument sign with landscaping",
        "public_id": "01a08cf2-3630-7347-aa06-59893fd55efd",
        "storage_key": "property/6737460151192641/01a08cf2-3630-7347-aa06-59893fd55efd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to Park Place at Foley, a beautifully landscaped community with a prominent brick monument sign.",
      "link": "",
      "alt_text": "Park Place at Foley monument sign with landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_464c354b-baa1-4dfb-9c34-e1ef7f6c86a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-2c21-74dd-9cc2-0175d4fdaef4.webp",
      "image_media": {
        "alt_text": "Interior closet space with bi-fold doors and shelving.",
        "public_id": "01a08cf2-2c21-74dd-9cc2-0175d4fdaef4",
        "storage_key": "property/6737460151192641/01a08cf2-2c21-74dd-9cc2-0175d4fdaef4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and a neutral color palette, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Interior closet space with bi-fold doors and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab6826d4-fff6-4208-9307-4de0a616c0ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-290f-716f-841b-a0dedcdba346.webp",
      "image_media": {
        "alt_text": "A well-lit bathroom with a vanity, toilet, and modern art.",
        "public_id": "01a08cf2-290f-716f-841b-a0dedcdba346",
        "storage_key": "property/6737460151192641/01a08cf2-290f-716f-841b-a0dedcdba346.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a granite countertop vanity, stylish fixtures, and decorative artwork.",
      "link": "",
      "alt_text": "A well-lit bathroom with a vanity, toilet, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88914bcb-acaf-4f40-bab6-147575c18c99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/01a08cf2-3054-7138-965b-b629b8bc48d5.webp",
      "image_media": {
        "alt_text": "Apartment dog grooming station with wash tub and grooming tables.",
        "public_id": "01a08cf2-3054-7138-965b-b629b8bc48d5",
        "storage_key": "property/6737460151192641/01a08cf2-3054-7138-965b-b629b8bc48d5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Convenient on-site dog grooming station for residents to pamper their pets.",
      "link": "",
      "alt_text": "Apartment dog grooming station with wash tub and grooming tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de96459c-1393-4193-95f4-83e81ca435c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6480-c237-706d-89d2-2f08210dc2e4.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e6480-c237-706d-89d2-2f08210dc2e4",
        "storage_key": "property/6737460151192641/019e6480-c237-706d-89d2-2f08210dc2e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and shaded areas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c3b816b-7cfa-497f-a8a5-efad3e0c6196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6480-ad1b-7562-8784-9051b9cefc5f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e6480-ad1b-7562-8784-9051b9cefc5f",
        "storage_key": "property/6737460151192641/019e6480-ad1b-7562-8784-9051b9cefc5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, granite countertops, and a full suite of black appliances. Includes a separate laundry area.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ee339795-1360-40ce-9173-d0a5b9283505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6481-56fe-7161-971e-d7aaf15a4caf.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019e6481-56fe-7161-971e-d7aaf15a4caf",
        "storage_key": "property/6737460151192641/019e6481-56fe-7161-971e-d7aaf15a4caf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50e15326-41a4-4017-ac2d-046b7992e29e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6481-4f43-741f-b876-f1de80da23ab.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings, swimming pool, and landscaping.",
        "public_id": "019e6481-4f43-741f-b876-f1de80da23ab",
        "storage_key": "property/6737460151192641/019e6481-4f43-741f-b876-f1de80da23ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our vibrant apartment community featuring a sparkling swimming pool, lush green spaces, and well-maintained buildings. Experience comfortable living in a beautiful setting.",
      "link": "",
      "alt_text": "Aerial view of apartment complex buildings, swimming pool, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d30a907-9352-4d9f-b943-046cae56125d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6481-1b1b-7360-884b-3e320829816d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and surrounding grounds.",
        "public_id": "019e6481-1b1b-7360-884b-3e320829816d",
        "storage_key": "property/6737460151192641/019e6481-1b1b-7360-884b-3e320829816d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our vibrant community featuring modern apartment buildings, a refreshing swimming pool, and lush green spaces, offering the perfect blend of comfort and convenience.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a swimming pool and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0348033-c878-479f-a8c1-48934cbc40ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6480-bbe2-72b3-86cd-13d49c43da6b.webp",
      "image_media": {
        "alt_text": "Aerial view of a sparkling blue swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e6480-bbe2-72b3-86cd-13d49c43da6b",
        "storage_key": "property/6737460151192641/019e6480-bbe2-72b3-86cd-13d49c43da6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and shaded areas perfect for relaxation.",
      "link": "",
      "alt_text": "Aerial view of a sparkling blue swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e462f4f9-d21c-4d93-abd2-271e8094950f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e6480-74ef-72fe-9639-6f6023c3ead1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with table and chairs under a pergola, apartment buildings in background.",
        "public_id": "019e6480-74ef-72fe-9639-6f6023c3ead1",
        "storage_key": "property/6737460151192641/019e6480-74ef-72fe-9639-6f6023c3ead1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining in our community grilling area, perfect for gatherings and relaxing with neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with table and chairs under a pergola, apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4f4c10e5-a90a-4cad-a532-14a7c0380a37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Lambert's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2981 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Folksy local chain with classic Southern-American fare & \"throwed rolls.\"",
      "poi_long_description": "Diners like this restaurant's delicious southern home-style cooking, including hearty entrees and flavorful pass-around sides like fried okra and potatoes. They also highlight the generous portions, ensuring guests leave full, and the reasonable prices. Visitors enjoy the fun, lively atmosphere, especially the unique experience of catching hot, fresh rolls thrown across the dining room, and consistently praise the friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9cad-72cf-a855-510a36b0a41c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9cad-72cf-a855-510a36b0a41c",
        "storage_key": "property/6737460151192641/019e1ddd-9cad-72cf-a855-510a36b0a41c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.throwedrolls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5918366913316344219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lamberts-cafe",
      "poi_latitude": "30.3707774",
      "poi_longitude": "-87.68213829999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-943-7655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7370-732a-aeb0-fa138be6172a",
        "storage_key": "property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7Zjm8wPmogRm1GlzllDIlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_77d60bbc-8f39-4158-9c15-1a622a3203d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "The Tin Top Restaurant & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "17451 County Rd 49 S, Bon Secour, AL 36511, USA",
      "poi_short_description": "No-frills bayside destination for choice seafood, large oysters & classic fried green tomatoes.",
      "poi_long_description": "People say this oyster bar restaurant serves fresh seafood, including baked oysters, crab claws, and trigger fish, as well as gumbo, shrimp and grits, and prime rib. They highlight the delicious sauces, generous portions, and the beautiful waterfront location with indoor and outdoor seating. They also like the friendly and attentive staff, and the live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9c27-72db-9256-2aaf91d96fb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9c27-72db-9256-2aaf91d96fb3",
        "storage_key": "property/6737460151192641/019e1ddd-9c27-72db-9256-2aaf91d96fb3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tintoprestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11298239525497669506&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-tin-top-restaurant--oyster-bar",
      "poi_latitude": "30.311489",
      "poi_longitude": "-87.7259924",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 251-949-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7370-732a-aeb0-fa138be6172a",
        "storage_key": "property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJefev2IUamogRggeR4Pxoy5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "oyster_bar_restaurant"
    },
    {
      "id": "custom_9dc26676-bd78-4421-9986-4afb9cc11436",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3013 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious salads. They highlight the fresh, hot food and the quick, polite service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9fc1-732c-9bd8-3d8cdc6f7257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9fc1-732c-9bd8-3d8cdc6f7257",
        "storage_key": "property/6737460151192641/019e1ddd-9fc1-732c-9bd8-3d8cdc6f7257.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/al/foley?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7051587261025525263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "30.3699001",
      "poi_longitude": "-87.68239799999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-971-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7370-732a-aeb0-fa138be6172a",
        "storage_key": "property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8Vem8wPmogRD54YxEBF3GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_bf1e31b4-17db-4853-a8ad-135e902f9679",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3311 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners praise the delicious steaks, ribs, and signature rolls served with cinnamon butter, alongside a wide array of side dish options. The welcoming and family-friendly atmosphere is frequently mentioned, as is the friendly staff.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a0d8-721f-aab3-fd92ac5eb3b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a0d8-721f-aab3-fd92ac5eb3b0",
        "storage_key": "property/6737460151192641/019e1ddd-a0d8-721f-aab3-fd92ac5eb3b0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/foley?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856905305018090783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "30.364694",
      "poi_longitude": "-87.6824626",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-270-4244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7370-732a-aeb0-fa138be6172a",
        "storage_key": "property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY30LRR8PmogRH0UALhDC7-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_19961a9c-9231-4115-aea6-02444e209822",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Wolf Bay Restaurant at Foley",
      "poi_type": "Restaurants",
      "poi_address": "20801 Miflin Rd, Foley, AL 36535, USA",
      "poi_short_description": "Bustling stop for local seafood, sandwiches & a salad bar in a long-running venture.",
      "poi_long_description": "Diners praise the delicious seafood, including fried shrimp and blackened whitefish, and the exceptional and fresh salad bar. They also highlight the friendly staff and good value for the quality and good portion sizes.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a159-71a0-adfe-40bfc819f336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a159-71a0-adfe-40bfc819f336",
        "storage_key": "property/6737460151192641/019e1ddd-a159-71a0-adfe-40bfc819f336.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wolfbaylodge.com/wolf-bay-restaurant-foley-al",
      "poi_directions_map_url": "https://maps.google.com/?cid=4786061274655514564&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wolf-bay-restaurant-at-foley",
      "poi_latitude": "30.3709259",
      "poi_longitude": "-87.6687022",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-987-5129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7370-732a-aeb0-fa138be6172a",
        "storage_key": "property/6737460151192641/019e1dde-7370-732a-aeb0-fa138be6172a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6bOLt0ImogRxF8YJV-Ba0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_228c7f5d-4615-4953-9135-6515703465f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Tanger Outlets Foley",
      "poi_type": "Shopping & Retail",
      "poi_address": "2601 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "People say this outlet mall offers a wide variety of brand-name and designer stores, with many opportunities to find great deals and sales. Visitors also highlight the clean and well-maintained grounds, including spotless restrooms and ample parking. They also mention the friendly and helpful staff, contributing to an enjoyable shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a41f-721d-b033-86f628ed30ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a41f-721d-b033-86f628ed30ca",
        "storage_key": "property/6737460151192641/019e1ddd-a41f-721d-b033-86f628ed30ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/foley",
      "poi_directions_map_url": "https://maps.google.com/?cid=4092886600814833726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanger-outlets-foley",
      "poi_latitude": "30.3763263",
      "poi_longitude": "-87.68018719999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-943-9303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7330-7261-b54c-656c4b56f0e6",
        "storage_key": "property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuxOaTTEOmogRPjCGq63azDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cfaee2e4-9893-49af-baad-080e8cba0c50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Publix Super Market at Colonial Promenade at Craft Farms",
      "poi_type": "Shopping & Retail",
      "poi_address": "160 Cotton Creek Dr Ste 100, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Shoppers say this supermarket offers a great selection of products, including fresh produce, a deli, and a hot food bar, with many mentioning the chicken tenders and fried chicken. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9bed-7468-b57e-759be83a7b0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9bed-7468-b57e-759be83a7b0b",
        "storage_key": "property/6737460151192641/019e1ddd-9bed-7468-b57e-759be83a7b0b.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1292&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=4133776225617508110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-colonial-promenade-at-craft-farms",
      "poi_latitude": "30.298598",
      "poi_longitude": "-87.6813592",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-948-1281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-736b-71e6-ac92-7d2f9298206f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-736b-71e6-ac92-7d2f9298206f",
        "storage_key": "property/6737460151192641/019e1dde-736b-71e6-ac92-7d2f9298206f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXxkcgsFmogRDvfiVJMfXjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_416f6ad1-be30-4568-addf-aebfcbee6873",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "3101 S McKenzie St #59, Foley, AL 36535, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Customers consistently praise this home improvement store for its well-organized layout and extensive selection of materials, hardware, and tools suitable for various projects. Reviewers also frequently mention the friendly and knowledgeable staff, along with the store's good prices.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9bba-746f-b8c5-3a0461fa6761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9bba-746f-b8c5-3a0461fa6761",
        "storage_key": "property/6737460151192641/019e1ddd-9bba-746f-b8c5-3a0461fa6761.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/AL-Foley/0577?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-577-_-na-_-0-_-0&y_source=1_MTE4MjkyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9362649965286582540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "30.368796",
      "poi_longitude": "-87.680236",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-970-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7330-7261-b54c-656c4b56f0e6",
        "storage_key": "property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTb1VD8sPmogRDOk6uYnQ7oE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fc9d901f-1162-40dc-8759-57a4c73a9246",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2899 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products, including tools, paint, appliances, and garden supplies, with helpful and knowledgeable staff. They also highlight the competitive prices and convenient online ordering and in-store pickup options.\n\nSome reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a0d1-77cf-9108-4ed65e4ef9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a0d1-77cf-9108-4ed65e4ef9e2",
        "storage_key": "property/6737460151192641/019e1ddd-a0d1-77cf-9108-4ed65e4ef9e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Foley/AL/Foley/36535/802?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11221938110406154794&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "30.3721412",
      "poi_longitude": "-87.68014629999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-955-2401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7330-7261-b54c-656c4b56f0e6",
        "storage_key": "property/6737460151192641/019e1dde-7330-7261-b54c-656c4b56f0e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn8_AhjMOmogRKlotSkFVvJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_db57a99c-9082-42d0-b26e-3685166f29df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Publix Super Market at Riviera Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2614 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this grocery store is consistently clean and well-stocked with a wide variety of fresh produce, deli items, and ready-to-eat meals. They also highlight the friendly and helpful staff, who often go above and beyond to assist customers. Visitors appreciate the convenient BOGO deals and the overall pleasant shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-9cf8-7571-85e7-7203f4c98208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-9cf8-7571-85e7-7203f4c98208",
        "storage_key": "property/6737460151192641/019e1ddd-9cf8-7571-85e7-7203f4c98208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1673&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=11280378365282435382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-riviera-square",
      "poi_latitude": "30.3771261",
      "poi_longitude": "-87.68634899999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-943-3329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-736b-71e6-ac92-7d2f9298206f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-736b-71e6-ac92-7d2f9298206f",
        "storage_key": "property/6737460151192641/019e1dde-736b-71e6-ac92-7d2f9298206f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSewVhn4PmogRNkGpclv0i5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_099c3186-1823-43fd-8706-476d724a3c94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Columbia Southern University",
      "poi_type": "Education",
      "poi_address": "21982 University Ln, Orange Beach, AL 36561, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a4dc-775c-b77e-5c999b2f0438.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a4dc-775c-b77e-5c999b2f0438",
        "storage_key": "property/6737460151192641/019e1ddd-a4dc-775c-b77e-5c999b2f0438.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.columbiasouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=838870487415983125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-southern-university",
      "poi_latitude": "30.3292725",
      "poi_longitude": "-87.6532483",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-981-3771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7394-754f-af40-0771b3a993b7",
        "storage_key": "property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAe-K4nsPmogRFQz9hkNEpAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_37f440dc-9cea-401c-823a-4332ee067bc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley Public Library",
      "poi_type": "Education",
      "poi_address": "319 E Laurel Ave, Foley, AL 36535, USA",
      "poi_short_description": "Public library offering books, movies, computer access, and a comfortable, welcoming atmosphere.",
      "poi_long_description": "People say this library offers a wide variety of classes for all ages and provides easy access to a computer lab and print station. They also highlight the clean and spacious facilities, including a seed library and a small store. Visitors consistently mention the friendly and helpful staff, who create a welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a778-7309-96fa-e700306e9984.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a778-7309-96fa-e700306e9984",
        "storage_key": "property/6737460151192641/019e1ddd-a778-7309-96fa-e700306e9984.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.foleylibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1862340374975031116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-public-library",
      "poi_latitude": "30.4069437",
      "poi_longitude": "-87.6790606",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-943-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7394-754f-af40-0771b3a993b7",
        "storage_key": "property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNXogHQ0OmogRTCdBNbRc2Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_41825074-8587-4616-af22-38231f855705",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Coastal Alabama Community College: Gulf Shores Campus",
      "poi_type": "Education",
      "poi_address": "3301 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-ad57-74df-aa09-438aef8fe10b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-ad57-74df-aa09-438aef8fe10b",
        "storage_key": "property/6737460151192641/019e1ddd-ad57-74df-aa09-438aef8fe10b.webp",
        "width": 1280,
        "height": 601
      },
      "poi_business_url": "https://www.coastalalabama.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733699067929643783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coastal-alabama-community-college-gulf-shores-campus",
      "poi_latitude": "30.2891209",
      "poi_longitude": "-87.6861287",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 251-968-3104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7394-754f-af40-0771b3a993b7",
        "storage_key": "property/6737460151192641/019e1dde-7394-754f-af40-0771b3a993b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO-HWzjoFmogRB0vjxW7C9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c7d56d4e-b450-4bce-870b-a2c3a7de2668",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Tropic Falls at OWA",
      "poi_type": "Entertainment",
      "poi_address": "1501 S Owa Blvd, Foley, AL 36535, USA",
      "poi_short_description": "Playful theme park with 22 rides from roller coasters to spinning tea cups, plus games & shows.",
      "poi_long_description": "People say this amusement park offers a variety of fun rides, including a roller coaster, and an indoor water park with slides, a lazy river, and a wave pool. They also highlight the friendly staff, the family-friendly atmosphere, and the good value of season passes.\n\nOther reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a9e6-73ab-bf1e-6efc64d64bc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a9e6-73ab-bf1e-6efc64d64bc4",
        "storage_key": "property/6737460151192641/019e1ddd-a9e6-73ab-bf1e-6efc64d64bc4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://visitowa.com/destinations/tropic-falls-at-owa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12545438543766947597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tropic-falls-at-owa",
      "poi_latitude": "30.3737323",
      "poi_longitude": "-87.6580479",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-923-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QRAIP8OmogRDQe5EONZGq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_2941b0c2-2cb7-490d-ba4c-eba553ae4c30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Alabama Gulf Coast Zoo",
      "poi_type": "Entertainment",
      "poi_address": "20499 Oak Rd E, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Home to more than 500 animals, this zoo offers hands-on experiences with kangaroos & other critters.",
      "poi_long_description": "Visitors say this zoo offers a fun, family-friendly experience with highlights like giraffe feeding, a petting area, playgrounds, and a carousel. They also like the friendly staff, clean facilities, and well-maintained exhibits.\n\nSome reviews mention the ticket prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a9e3-7794-81ad-e02a87944e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a9e3-7794-81ad-e02a87944e8d",
        "storage_key": "property/6737460151192641/019e1ddd-a9e3-7794-81ad-e02a87944e8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://alabamagulfcoastzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9777256349209079055&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alabama-gulf-coast-zoo",
      "poi_latitude": "30.3157177",
      "poi_longitude": "-87.6762971",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-256-7008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_yEkM8EmogRDy2K9NjKr4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_5b654f0f-a6cd-4355-8788-789f261b9ead",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "The Track - Gulf Shores",
      "poi_type": "Entertainment",
      "poi_address": "3200 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Outdoor amusement park with go-kart tracks & bumper boats, plus roller coasters & arcade games.",
      "poi_long_description": "People say this amusement park offers a variety of go-kart tracks, mini golf, and an arcade. They also highlight the fun experience for all ages, the friendly staff, and the clean facilities.\n\nSome reviews mention the go-karts can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-a97c-762c-b855-6d650920b4c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-a97c-762c-b855-6d650920b4c2",
        "storage_key": "property/6737460151192641/019e1ddd-a97c-762c-b855-6d650920b4c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.funatthetrack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=510154717045743835&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-track---gulf-shores",
      "poi_latitude": "30.2864132",
      "poi_longitude": "-87.68571519999999",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 251-270-0209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQO2vSUFmogR22AAIgNvFAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_57cda1ed-f44b-4f04-b522-a08ef148190d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 E Laurel Ave, Foley, AL 36535, USA",
      "poi_short_description": "Free museum featuring a huge, remote-controlled model railroad, real train cars & other exhibits.",
      "poi_long_description": "Visitors say this museum offers an impressive model train exhibit, restored train cars to explore, and engaging displays on local history. They also highlight the free admission, making it a great value for families. Guests mention the staff are friendly, welcoming, and knowledgeable, enhancing the overall experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-ae98-774b-bc4a-4fc3660965ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-ae98-774b-bc4a-4fc3660965ad",
        "storage_key": "property/6737460151192641/019e1ddd-ae98-774b-bc4a-4fc3660965ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.foleyrailroadmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14104774791946772885&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-railroad-museum",
      "poi_latitude": "30.406891",
      "poi_longitude": "-87.6829073",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-943-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73d8-722c-90c5-1d4f770b2a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73d8-722c-90c5-1d4f770b2a01",
        "storage_key": "property/6737460151192641/019e1dde-73d8-722c-90c5-1d4f770b2a01.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9BIfA4OmogRlSHfZvE5vsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a4a77cdd-076e-449e-896e-6ab48486c1b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Mickey Miller Blackwell Stadium",
      "poi_type": "Entertainment",
      "poi_address": "19025 Oak Rd W, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-aefa-723e-a492-92a71bc53f94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-aefa-723e-a492-92a71bc53f94",
        "storage_key": "property/6737460151192641/019e1ddd-aefa-723e-a492-92a71bc53f94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stadiumconnection.com/al/stadium.php?id=5211",
      "poi_directions_map_url": "https://maps.google.com/?cid=2412152959264021276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mickey-miller-blackwell-stadium",
      "poi_latitude": "30.3140472",
      "poi_longitude": "-87.69948269999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73cf-763f-98e9-3f7f58108d48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73cf-763f-98e9-3f7f58108d48",
        "storage_key": "property/6737460151192641/019e1dde-73cf-763f-98e9-3f7f58108d48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA_ve0tgbmogRHNvWGFaweSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0614dc87-5843-49a1-ad61-9eff0e294869",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1639 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Chain gym offering memberships and classes, plus tanning, hydromassage, and massage chairs.",
      "poi_long_description": "Reviewers consistently praise this gym for its wide variety of modern equipment, including numerous cardio and resistance machines. The friendly staff and knowledgeable coaches are also frequently highlighted as positive aspects of the facility.\n\nSome reviews mention the equipment can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-aee8-76ff-b84b-ca0f763760b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-aee8-76ff-b84b-ca0f763760b5",
        "storage_key": "property/6737460151192641/019e1ddd-aee8-76ff-b84b-ca0f763760b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/foley-al?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11282239276772096848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.388004",
      "poi_longitude": "-87.6816319",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-943-9370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6o6oj4OmogRUPv1qtiQkpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6de9456a-03f9-49aa-a710-40b6c21d379d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "The John McClure Snook Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2560 S Pine St, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b272-70c8-ae78-a356c84fe27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b272-70c8-ae78-a356c84fe27d",
        "storage_key": "property/6737460151192641/019e1ddd-b272-70c8-ae78-a356c84fe27d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ysal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1663587881379590489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-john-mcclure-snook-family-ymca",
      "poi_latitude": "30.3770559",
      "poi_longitude": "-87.6884594",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-970-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd75yhQ8OmogRWXFGMl1AFhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c396b4db-d48c-4952-af0f-9f8c3b5a351f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8154 AL-59 Ste 216, Foley, AL 36535, USA",
      "poi_short_description": "Fitness chain offering 24/7 access, as well as personal training and group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b2e6-70dc-8ac8-a792e38938bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b2e6-70dc-8ac8-a792e38938bd",
        "storage_key": "property/6737460151192641/019e1ddd-b2e6-70dc-8ac8-a792e38938bd.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/foley-alabama-3343/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3343",
      "poi_directions_map_url": "https://maps.google.com/?cid=14139556942997155357&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "30.343109",
      "poi_longitude": "-87.681911",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-923-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5KyNOoPmogRHe7ABCDMOcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_99c047fa-d411-447f-8d94-c750e67bfbe7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2438 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b335-75cb-b68c-6bf4358fef8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b335-75cb-b68c-6bf4358fef8e",
        "storage_key": "property/6737460151192641/019e1ddd-b335-75cb-b68c-6bf4358fef8e.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/al/foley/2438-s-mckenzie-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14513001249459693465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "30.3801064",
      "poi_longitude": "-87.68618169999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-972-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJldmBbDAOmogRmWfYQr6JaMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_77f2a071-3acc-442a-9766-be323c0ceb60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Fitness Factory",
      "poi_type": "Health and Wellness",
      "poi_address": "3501 Gulf Shores Pkwy STE 9, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Gym with 24/7 access offering a variety of equipment, day or week passes, and a welcoming environment.",
      "poi_long_description": "Visitors say this gym offers a wide variety of well-maintained equipment, including free weights, machines, and cardio options, and is suitable for serious training. They also highlight the friendly and helpful staff, as well as the clean facilities. Guests mention the convenient day pass system and the motivating, community-like atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b418-71df-96e7-2306328fce2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b418-71df-96e7-2306328fce2a",
        "storage_key": "property/6737460151192641/019e1ddd-b418-71df-96e7-2306328fce2a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://fitnessfactorynow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=189161923044219216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-factory",
      "poi_latitude": "30.292598",
      "poi_longitude": "-87.684975",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 251-426-5247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUIF01gFmogRUJkUTMQJoAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_efaf7681-218e-4569-841d-9bdd7dd44871",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Dykes Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "512 W Laurel Ave, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b538-754d-9037-40f9a27f9b9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b538-754d-9037-40f9a27f9b9e",
        "storage_key": "property/6737460151192641/019e1ddd-b538-754d-9037-40f9a27f9b9e.webp",
        "width": 1280,
        "height": 980
      },
      "poi_business_url": "https://www.dykesvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8758829931646015936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dykes-veterinary-clinic",
      "poi_latitude": "30.4070672",
      "poi_longitude": "-87.69273009999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-943-3211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSMYBgMOmogRwNnRo2qdjXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a5685c15-92cd-4459-8d4f-6a267032895d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Langston Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6849 AL-59, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b5aa-75ac-9a21-e54abe77d88f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b5aa-75ac-9a21-e54abe77d88f",
        "storage_key": "property/6737460151192641/019e1ddd-b5aa-75ac-9a21-e54abe77d88f.webp",
        "width": 784,
        "height": 295
      },
      "poi_business_url": "http://langstonanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1387974155124890868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "langston-animal-hospital",
      "poi_latitude": "30.3243281",
      "poi_longitude": "-87.6836691",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-943-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgX0xeo4FmogR9Fyk6SMTQxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0d5a9e3b-fde5-4708-a738-16e49389ddc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Auburn Veterinary Specialists - Gulf Shores",
      "poi_type": "Health and Wellness",
      "poi_address": "21541 Co Rd 8, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b780-73b0-80f9-c914f04c1a1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b780-73b0-80f9-c914f04c1a1d",
        "storage_key": "property/6737460151192641/019e1ddd-b780-73b0-80f9-c914f04c1a1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.vetmed.auburn.edu/animal-owners/gulf_shores/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2092345368431673921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-veterinary-specialists---gulf-shores",
      "poi_latitude": "30.3276785",
      "poi_longitude": "-87.6561033",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 251-227-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZSDapEPmogRQcLN4AaBCR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4474fd06-c181-4ee5-88bc-e28553d6adf5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Eduardo's BarberShop",
      "poi_type": "Health and Wellness",
      "poi_address": "8735 A AL-59, Foley, AL 36535, USA",
      "poi_short_description": "Appointments are recommended at this barber shop, which also offers beard trims and perms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b6ba-7206-a8d1-fda559254531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b6ba-7206-a8d1-fda559254531",
        "storage_key": "property/6737460151192641/019e1ddd-b6ba-7206-a8d1-fda559254531.webp",
        "width": 1080,
        "height": 788
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430063055254981748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eduardos-barbershop",
      "poi_latitude": "30.351643",
      "poi_longitude": "-87.6837628",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-494-8202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxfPhi0OmogRdAzW40csPFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_58afa99c-2938-4187-b753-e828aeea03e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Baldwin Health",
      "poi_type": "Health and Wellness",
      "poi_address": "1613 N McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b724-760b-9bb0-420cd261f287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b724-760b-9bb0-420cd261f287",
        "storage_key": "property/6737460151192641/019e1ddd-b724-760b-9bb0-420cd261f287.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.baldwinhealth.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=7408245077329768860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baldwin-health",
      "poi_latitude": "30.4260622",
      "poi_longitude": "-87.6843473",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 251-949-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73f5-7768-b871-27e7fd46a8d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73f5-7768-b871-27e7fd46a8d4",
        "storage_key": "property/6737460151192641/019e1dde-73f5-7768-b871-27e7fd46a8d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5HSkeUNmogRnPFGs6Vfz2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e67dc6c4-663a-4625-baad-15d165aeaf6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Mercy Medical Health Center of Gulf Shores",
      "poi_type": "Health and Wellness",
      "poi_address": "3849 Gulf Shores Pkwy STE 9, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b8c1-747a-bc39-129a2a449856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b8c1-747a-bc39-129a2a449856",
        "storage_key": "property/6737460151192641/019e1ddd-b8c1-747a-bc39-129a2a449856.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "https://www.facebook.com/mmhcgulfshores",
      "poi_directions_map_url": "https://maps.google.com/?cid=5772447217262559534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-medical-health-center-of-gulf-shores",
      "poi_latitude": "30.30559",
      "poi_longitude": "-87.68392560000001",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-957-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73f5-7768-b871-27e7fd46a8d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73f5-7768-b871-27e7fd46a8d4",
        "storage_key": "property/6737460151192641/019e1dde-73f5-7768-b871-27e7fd46a8d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTT8YisQFmogRLoGgDSnaG1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_3f475404-f583-4588-b211-9854a1cb0ad7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Craft Farms Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3840 Cotton Creek Cir, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course offers two well-maintained courses with beautiful fairways and greens. They highlight the fun and challenging layouts, and the excellent condition of the courses. They also like the friendly and helpful staff, and the welcoming hospitality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-b9f7-728a-8e9e-16b2fead856e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-b9f7-728a-8e9e-16b2fead856e",
        "storage_key": "property/6737460151192641/019e1ddd-b9f7-728a-8e9e-16b2fead856e.webp",
        "width": 1280,
        "height": 760
      },
      "poi_business_url": "http://www.craftfarms.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5669825570055768880&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "craft-farms-golf-club",
      "poi_latitude": "30.304877",
      "poi_longitude": "-87.6668937",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 251-968-3002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73cf-763f-98e9-43a9d85b444d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73cf-763f-98e9-43a9d85b444d",
        "storage_key": "property/6737460151192641/019e1dde-73cf-763f-98e9-43a9d85b444d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTYCCJHIFmogRMMuZ4VBEr04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_447c926e-0655-4236-9e4a-b1fdb23420eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Graham Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23030 Wolf Bay Dr, Foley, AL 36535, USA",
      "poi_short_description": "Nearly-500-acre preserve with a visitor center, hiking & biking trails & 2 disc-golf courses.",
      "poi_long_description": "People say this nature preserve offers a variety of outdoor activities, including hiking, biking, archery, disc golf, and kayaking. They highlight the beautiful setting, the free access to many amenities, and the well-maintained trails and facilities. They also like the quiet and peaceful atmosphere, and the abundance of wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-d532-700a-bb19-26441d22069c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-d532-700a-bb19-26441d22069c",
        "storage_key": "property/6737460151192641/019e1ddd-d532-700a-bb19-26441d22069c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://grahamcreekpreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8438383121018525009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "graham-creek-nature-preserve",
      "poi_latitude": "30.347877",
      "poi_longitude": "-87.63255219999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-923-4267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-742a-7482-a594-8e96ad3b7000",
        "storage_key": "property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu86pjjYPmogRURX2dr0oG3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_6bba20c2-7ab3-4360-91ba-0f40e94b0df0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Sportsplex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19025 Co Rd 6, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-bdc2-765e-9fbd-0b5ea708b1a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-bdc2-765e-9fbd-0b5ea708b1a4",
        "storage_key": "property/6737460151192641/019e1ddd-bdc2-765e-9fbd-0b5ea708b1a4.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14524334490545458573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sportsplex",
      "poi_latitude": "30.3154958",
      "poi_longitude": "-87.69817379999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-742a-7482-a594-8e96ad3b7000",
        "storage_key": "property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXiisEIFmogRjY3qE0TNkMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d4a999f-0870-4419-9619-614fc990b910",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley Kids Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "209 W Verbena Ave, Foley, AL 36535, USA",
      "poi_short_description": "Family site with playground equipment & castles, picnic facilities, ball fields & a swimming pool.",
      "poi_long_description": "People say this park features a variety of play equipment beyond typical swings and slides, including climbing structures and a skatepark. Visitors also highlight the clean and well-maintained play areas, with many appreciating the shaded sections. They also mention it's a safe and fun environment for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-d8b3-7785-b57b-7a95116bec62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-d8b3-7785-b57b-7a95116bec62",
        "storage_key": "property/6737460151192641/019e1ddd-d8b3-7785-b57b-7a95116bec62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityoffoley.org/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336158403840427884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-kids-park",
      "poi_latitude": "30.4027342",
      "poi_longitude": "-87.6865528",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-943-8897",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-742a-7482-a594-8e96ad3b7000",
        "storage_key": "property/6737460151192641/019e1dde-742a-7482-a594-8e96ad3b7000.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65WzOxAOmogRbMd3ugEgUp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_34f77760-e05e-489b-b9ea-6d319c0b8194",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Gulf Links Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3901 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course is a fun, challenging, and inexpensive option, with greens often in terrific shape and a good layout for beginners. They also highlight the friendly and helpful staff, as well as the great value for the price.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-e02f-732b-a967-958066f44492.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-e02f-732b-a967-958066f44492",
        "storage_key": "property/6737460151192641/019e1ddd-e02f-732b-a967-958066f44492.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gulflinksgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9224264171960365741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gulf-links-golf-course",
      "poi_latitude": "30.3561971",
      "poi_longitude": "-87.681998",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-970-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-73cf-763f-98e9-43a9d85b444d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-73cf-763f-98e9-43a9d85b444d",
        "storage_key": "property/6737460151192641/019e1dde-73cf-763f-98e9-43a9d85b444d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2UYys4PmogRrXIPZGQrA4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f85531c1-faec-4e49-9cfe-d3b8e31c62c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Gulf Shores International Airport at Jack Edwards Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "1155 Commerce Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this airport is small, easy to navigate, and offers a smooth security process with short lines. They also highlight the friendly and helpful staff, convenient parking, and affordable flights.\n\nSome reviews mention the parking can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-d3c3-7506-a41d-df960aab0d25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-d3c3-7506-a41d-df960aab0d25",
        "storage_key": "property/6737460151192641/019e1ddd-d3c3-7506-a41d-df960aab0d25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://flyjka.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13430190755623891884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gulf-shores-international-airport-at-jack-edwards-field",
      "poi_latitude": "30.287539",
      "poi_longitude": "-87.672506",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 251-967-3968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7e55-775c-94d3-8b3f7a2675cf",
        "storage_key": "property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ0ldRAFmogRrHOyBlafYbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9e6ec224-e0fd-4ab2-b9f9-893357871dca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley Municipal Airport (5R4)",
      "poi_type": "Transportation & Transit",
      "poi_address": "510 Airport Dr, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-d92b-719d-8645-044d360506e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-d92b-719d-8645-044d360506e2",
        "storage_key": "property/6737460151192641/019e1ddd-d92b-719d-8645-044d360506e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lightningaviationfoley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1217533773294040099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-municipal-airport-5r4",
      "poi_latitude": "30.428159",
      "poi_longitude": "-87.7020028",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-943-5214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7e55-775c-94d3-8b3f7a2675cf",
        "storage_key": "property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6xIeAQSmogRI3Q7G4SM5RA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7953cd8c-bab6-4490-b5c1-91404e775ef6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Barin Nolf Airfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "Summerdale, AL 36580, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-d3c6-748e-bfcd-6f973a4b851b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-d3c6-748e-bfcd-6f973a4b851b",
        "storage_key": "property/6737460151192641/019e1ddd-d3c6-748e-bfcd-6f973a4b851b.webp",
        "width": 1280,
        "height": 659
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842150949897244092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barin-nolf-airfield",
      "poi_latitude": "30.3899152",
      "poi_longitude": "-87.6322113",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7e55-775c-94d3-8b3f7a2675cf",
        "storage_key": "property/6737460151192641/019e1dde-7e55-775c-94d3-8b3f7a2675cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ_5YccOmogRvA1GX4eikBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_204661c5-3e53-4af9-bc31-a7ba185b49b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "407 E Laurel Ave, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-df6e-7486-b2af-68d2745d5207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-df6e-7486-b2af-68d2745d5207",
        "storage_key": "property/6737460151192641/019e1ddd-df6e-7486-b2af-68d2745d5207.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cityoffoley.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11201058242619382430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-city-hall",
      "poi_latitude": "30.40701289999999",
      "poi_longitude": "-87.6780776",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 251-943-1545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7e59-75be-b899-73394382097c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7e59-75be-b899-73394382097c",
        "storage_key": "property/6737460151192641/019e1dde-7e59-75be-b899-73394382097c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAyd_KQ0OmogRnhrKOyAncps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_31f9fa69-88f2-4183-9312-56e9dedd484e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "Foley WIC Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8158 AL-59 #108, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://adph.org/wic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=711894088026459118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "foley-wic-office",
      "poi_latitude": "30.3436431",
      "poi_longitude": "-87.6820572",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-943-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBw3ELcIPmogR7ouEuuYn4Qk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cc5e0306-80eb-46c3-b565-72e4e6b5b689",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "poi_name": "RE/MAX on the Coast",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8158 AL-59 APT 102, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-e3b9-7410-a629-2b6b3c1a5f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-e3b9-7410-a629-2b6b3c1a5f5c",
        "storage_key": "property/6737460151192641/019e1ddd-e3b9-7410-a629-2b6b3c1a5f5c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.remaxonthecoast-al.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7618062826519444638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "remax-on-the-coast",
      "poi_latitude": "30.3436529",
      "poi_longitude": "-87.68220699999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-980-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-7433-76c1-8896-e3307c78bc82",
        "storage_key": "property/6737460151192641/019e1dde-7433-76c1-8896-e3307c78bc82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXoJLuoPmogRnrxMS8fLuGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ee967188-8d8d-43b0-99e3-1c2f9045cde7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f010e443-aa20-4bc9-a987-160b5cdc3219",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_370a1c99-385e-4c47-82f6-daaa0e7e3550",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_52ac2513-4754-44f7-9ffe-d9e003bf51e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_98fc1b90-e19c-4e7b-9a53-1cbe0ec8b0ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d0dc4a7f-a1c1-4822-a2b1-a9ef4e460c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_880c97a1-9610-4e51-ac37-6f26d8027afa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "rating": "5",
      "name": "Jonah Poe",
      "text": "Me my nanny and momma love it here! Since the new management has taken over we have seen great things. The property looks amazing and when you walk into the office your made to feel right at home. We are truly greatful for their hard work and genuine caring attitude when it comes to us and our needs. Thank you ladies!",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_01410f7f-e6d5-4a4f-a615-53103d7bd30d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "rating": "5",
      "name": "Nordia Warner",
      "text": "Todd Markwell did an excellent job fixing all the stuff I’d issue with",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_54d203c3-8d65-49dc-bc68-c7b6888794a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "rating": "5",
      "name": "Anjel Kuhn",
      "text": "The lady's that work here, Ashley and Asia, are amazing.They welcomed me and my daughter to our new home and immediately have made us feel like family. Like we finally belong somewhere. They deserve something for their love and hospitality.\nYou don't really meet people like them. I'm proud to say we will stay here for along time.",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_3f88e5dd-51a5-437a-963b-a49b22a69b85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "rating": "5",
      "name": "Brittney Montijo",
      "text": "The office team always works diligently to make sure we are pleased with our living space and always is there to hear out any concerns we may have!",
      "date": "2026-01-30",
      "title": "false"
    },
    {
      "id": "custom_533c50ff-0b60-4eee-b6e6-878e60961eb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "rating": "5",
      "name": "Mariah Hill",
      "text": "I’ve been here 3-4 years & Mrs Kristen has been an amazingly property manager.. she’s very understanding, & gets things done she has done a lot for this apartment complex!!! My family loves it here!",
      "date": "2026-01-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a62f4f42-1305-4913-a4cb-1097ca5a6fe0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019e1ddd-8b8e-7730-a4bc-3de06cdab3f2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1ddd-8b8e-7730-a4bc-3de06cdab3f2",
        "storage_key": "property/6737460151192641/019e1ddd-8b8e-7730-a4bc-3de06cdab3f2.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6667b4e7c378bb69e489a1a5"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e7f-1e06-7708-9498-cb38ea15fd30",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-park-place-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641"
    },
    {
      "lead_collector_id": "01996473-8457-757d-b73b-6414beacf8c3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-park-place-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641"
    },
    {
      "lead_collector_id": "019d6351-05b1-7593-80ad-98c049752af0",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "apartments-with-pool-foley",
      "search_query": "apartments with a pool in Foley AL",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Foley, AL",
      "h2_subtitle": "Discover stunning apartments with a pool in Foley, AL at Park Place. Enjoy resort-style amenities and beautiful surroundings, perfect for your lifestyle needs.",
      "page_copy": "If you're searching for apartments with a pool in Foley, AL, look no further than Park Place at Foley. Situated in the charming Baldwin County, Park Place offers a refreshing swimming pool among its impressive array of amenities. Ideal for both relaxation and recreation, our sparkling pool is the perfect spot to unwind after a long day or socialize with neighbors on the weekends.\n\nIn addition to the inviting pool, Park Place at Foley provides residents with a luxurious living experience. Choose from one, two, or three-bedroom floor plans and enjoy features like balconies and a sun-kissed sundeck. Set within a gated community, indulge in carefree living with on-site management to assist with all your needs. Make Park Place at Foley your new home and discover the pleasures of apartment living with elegant amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Foley, AL",
      "seo_description": "Discover Park Place's beautiful apartments with a pool in Foley, AL. Enjoy luxurious amenities in a serene, gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "luxury-apartments-ac-baldwin-county",
      "search_query": "luxury apartments with air conditioning Baldwin County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with AC in Baldwin County",
      "h2_subtitle": "Explore luxury apartments with air conditioning in Baldwin County. Experience the comfort and convenience at Park Place at Foley.",
      "page_copy": "Looking for luxury apartments with air conditioning in Baldwin County? Park Place at Foley meets all your expectations. Nestled in the picturesque setting of Foley, our community offers elegant one, two, and three-bedroom apartments that are equipped with modern air conditioning, ensuring comfort year-round.\n\nAt Park Place at Foley, luxury doesn't end with air conditioning. Our residents enjoy premium amenities such as a fitness center, spa, tennis courts, and a beautifully landscaped sundeck. This gated community is designed for those who appreciate the finer things in life, offering both tranquility and modern conveniences within reach. Discover unmatched luxury and comfort at Park Place at Foley, your perfect home in Baldwin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with AC in Baldwin County",
      "seo_description": "Discover luxury apartments with air conditioning at Park Place in Baldwin County, AL. Enjoy top-notch amenities and seamless comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "gated-community-apartments-fireplaces-foley",
      "search_query": "gated community apartments with fireplaces in Foley",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Foley",
      "h2_subtitle": "Find gated community apartments with fireplaces in Foley at Park Place. Enjoy a luxurious lifestyle with exceptional amenities and comfort.",
      "page_copy": "Discover the allure of gated community apartments with fireplaces in Foley, right here at Park Place at Foley. While our apartments feature a variety of floor plans and luxurious amenities, the warmth and ambiance of a cozy fireplace can be experienced through our community's inviting atmosphere and personal touches in design.\n\nPark Place at Foley promises a sophisticated living experience with amenities like a resident-exclusive fitness center, spa, and tennis courts, enhancing the community's luxurious feel. Residents enjoy relaxation and camaraderie at the on-site sundeck and picnic areas. Experience the serenity and security of gated community living at Park Place, where comfort meets style in the heart of Baldwin County's Foley.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Foley",
      "seo_description": "Explore gated community apartments at Park Place in Foley, AL. Enjoy luxurious living with exceptional amenities in a secure environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "foley-apartments-hardwood-floors",
      "search_query": "Foley apartments with hardwood floors",
      "category": "Amenity",
      "h1_title": "Foley Apartments with Hardwood Floors",
      "h2_subtitle": "Discover Foley apartments with hardwood floors at Park Place. Enjoy modern living with stylish interiors and exceptional amenities.",
      "page_copy": "For those seeking Foley apartments with hardwood floors, Park Place at Foley offers an elegant and modern living experience. These beautifully crafted floors provide a sleek and warm feel, complementing the luxurious interiors and spacious floor plans we offer.\n\nBeyond the stunning flooring, residents enjoy a host of top-tier amenities, including a fitness center, spa, and tennis courts, all within a gated community. Relax on the sundeck or picnic area and make the most of maintenance-free living with on-site management. Park Place at Foley combines the beauty of hardwood floors with a vibrant lifestyle, perfect for anyone looking to elevate their living experience in Baldwin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Foley Apartments with Hardwood Floors",
      "seo_description": "Explore Foley apartments featuring hardwood floors at Park Place. Enjoy modern, luxurious living with exceptional community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "apartments-high-speed-internet-foley-al",
      "search_query": "apartments with high speed internet Foley AL",
      "category": "Amenity",
      "h1_title": "Apartments with High-Speed Internet Foley AL",
      "h2_subtitle": "Enjoy high-speed internet in Foley AL with our apartments at Park Place. Experience seamless connectivity and upscale living.",
      "page_copy": "Searching for apartments with high-speed internet in Foley, AL? Look no further than Park Place at Foley. Our community ensures you're always connected, complementing your modern lifestyle with fast, reliable internet access as part of our comprehensive amenities.\n\nLiving at Park Place means more than just fast internet. Our luxurious setting offers one, two, and three-bedroom floor plans, each designed with comfort in mind. Residents enjoy exclusive access to amenities like a fitness center, spa, and tennis courts, all within a secure, gated community. With high-speed internet and top-notch amenities, Park Place is the ideal choice for working professionals and families in Baldwin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with High-Speed Internet Foley AL",
      "seo_description": "Discover Park Place apartments in Foley, AL, offering high-speed internet and upscale amenities in a secure, connected community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-foley-al",
      "search_query": "1 bedroom apartments foley al",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Foley, AL",
      "h2_subtitle": "Explore 1 bedroom apartments in Foley, AL at Park Place. Enjoy a blend of comfort and style in a prime location.",
      "page_copy": "Discover the perfect 1 bedroom apartments in Foley, AL at Park Place at Foley. Our modern and spacious one-bedroom units offer an ideal living environment, merging quality design with functionality. Whether you're a young professional or seeking a cozy space to call home, you'll appreciate the thoughtful layout and contemporary finishes.\n\nSituated in a vibrant, gated community, our residences come with luxurious perks like a fitness center, spa, and tennis courts. Enjoy the sunny Alabama days on the sundeck or at the picnic area, while our on-site management team handles maintenance needs. Choose Park Place at Foley for upscale living tailored to your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Foley, AL",
      "seo_description": "Find your ideal 1 bedroom apartment in Foley, AL at Park Place. Enjoy modern living with stylish interiors and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-baldwin-county",
      "search_query": "3 bedroom apartments baldwin county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Baldwin County",
      "h2_subtitle": "Discover spacious 3 bedroom apartments in Baldwin County at Park Place. Perfect for families seeking comfort and convenience.",
      "page_copy": "For families and those needing ample space, Park Place at Foley offers 3 bedroom apartments in Baldwin County that redefine modern living. These spacious layouts are designed to provide comfort and privacy, seamlessly blending style with functionality. Perfectly suited for families or individuals who value extra room, our apartments promise a welcoming environment in a coveted location.\n\nNestled within a gated community, Park Place provides access to an array of amenities including a fitness center, spa, and tennis courts. With a sundeck and picnic area, enjoyment is just steps from your door. Our on-site management team ensures maintenance-free living, making Park Place at Foley an excellent choice for anyone seeking a serene yet dynamic living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Baldwin County",
      "seo_description": "Explore 3 bedroom apartments in Baldwin County at Park Place, offering spacious, comfortable living with luxurious amenities in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192641",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-36535",
      "search_query": "2 bedroom apartments near 36535",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 36535",
      "h2_subtitle": "Find versatile 2 bedroom apartments near 36535 at Park Place. Enjoy modern living in a vibrant community with excellent amenities.",
      "page_copy": "Searching for the ideal 2 bedroom apartments near 36535? Park Place at Foley presents exquisite options that combine comfort and modern design. With spacious layouts perfect for roommates, small families, or those in need of extra space, our two-bedroom units offer a refined living experience augmented by high-quality finishes and design.\n\nLocated in the heart of Baldwin County, Park Place provides a range of amenities including a state-of-the-art fitness center, relaxing spa, and tennis courts—all within a secure, gated community. Residents also enjoy a sundeck and picnic area, enhancing their lifestyle with outdoor leisure. Choose Park Place at Foley and revel in the convenience and community spirit of living near the vibrant 36535 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a blue sky.",
        "public_id": "019d0784-cc41-7457-8de1-b9105e720823",
        "storage_key": "property/6737460151192641/019d0784-cc41-7457-8de1-b9105e720823.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 36535",
      "seo_description": "Discover spacious 2 bedroom apartments near 36535 at Park Place. Enjoy a blend of modern living and superior amenities in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4470"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483174"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973405"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W4P797BX"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "251-309-7479"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "251-714-7096"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "251-309-7482"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "251-714-7121"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "251-309-7352"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "251-309-7393"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "251-309-7396"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "251-309-7287"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "251-309-7364"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "251-309-7471"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "251-351-0340"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "251-351-7440"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "251-309-7263"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "251-360-3110"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "251-360-3372"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "251-325-1407"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "251-257-3789"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "251-309-7347"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "251-732-6412"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8442831891"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "251-309-7348"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "251-261-0276"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "ff9dce201ab911ee"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "251-360-3342"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "251-309-7216"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "251-309-7452"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "251-250-4171"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "251-714-7328"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "251-309-7214"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "251-309-7450"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.parkplaceatfoley.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192641/019e647e-cf31-744d-ae40-1e43e764929a.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "251-309-2913"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "251-351-0340"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "4470",
  "custom_repli_id": "5028483174",
  "custom_realpage_id": "4973405",
  "custom_knock_a_link": "https://www.parkplaceatfoley.com?utm_knock=a",
  "custom_knock_g_link": "https://www.parkplaceatfoley.com?utm_knock=g",
  "custom_knock_r_link": "https://www.parkplaceatfoley.com?utm_knock=r",
  "custom_knock_w_link": "https://www.parkplaceatfoley.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-W4P797BX",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.parkplaceatfoley.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.parkplaceatfoley.com?utm_knock=ar",
  "custom_knock_br_link": "https://www.parkplaceatfoley.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.parkplaceatfoley.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.parkplaceatfoley.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.parkplaceatfoley.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.parkplaceatfoley.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "251-309-7479",
  "custom_knock_ads_link": "https://www.parkplaceatfoley.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.parkplaceatfoley.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "251-714-7096",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.parkplaceatfoley.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.parkplaceatfoley.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.parkplaceatfoley.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.parkplaceatfoley.com?utm_knock=psa",
  "custom_knock_r_number": "251-309-7482",
  "custom_knock_w_number": "251-714-7121",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "251-309-7352",
  "custom_knock_amap_link": "https://www.parkplaceatfoley.com?utm_knock=amap",
  "custom_knock_ar_number": "251-309-7393",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "251-309-7396",
  "custom_knock_cl_number": "251-309-7287",
  "custom_knock_fb_number": "251-309-7364",
  "custom_knock_fl_number": "251-309-7471",
  "custom_knock_gp_number": "251-351-0340",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.parkplaceatfoley.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "251-351-7440",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.parkplaceatfoley.com?utm_knock=bcard",
  "custom_knock_bnr_number": "251-309-7263",
  "custom_knock_cfres_link": "https://www.parkplaceatfoley.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "251-360-3110",
  "custom_knock_lgp_number": "251-360-3372",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.parkplaceatfoley.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "251-325-1407",
  "custom_knock_psa_number": "251-257-3789",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "251-309-7347",
  "custom_knock_bandit_link": "https://www.parkplaceatfoley.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.parkplaceatfoley.com?utm_knock=flyers",
  "custom_knock_osoc_number": "251-732-6412",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "8442831891",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "251-309-7348",
  "custom_knock_cfres_number": "251-261-0276",
  "custom_knock_chatgpt_link": "https://www.parkplaceatfoley.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "ff9dce201ab911ee",
  "custom_knock_dirmail_link": "https://www.parkplaceatfoley.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "251-360-3342",
  "custom_knock_propbro_link": "https://www.parkplaceatfoley.com?utm_knock=propbro",
  "custom_knock_bandit_number": "251-309-7216",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "251-309-7452",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.parkplaceatfoley.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "251-250-4171",
  "custom_knock_dirmail_number": "251-714-7328",
  "custom_knock_propbro_number": "251-309-7214",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "251-309-7450",
  "custom_knock_maintenance_link": "https://www.parkplaceatfoley.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192641/019e647e-cf31-744d-ae40-1e43e764929a.mp4",
  "custom_knock_maintenance_number": "251-309-2913",
  "custom_ppc_tracking_phone_number": "251-351-0340"
};

export const generatedAt = '2026-10-07T17:13:19.369Z';
